import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "className", "inputClassname", "format", "calendarProps", "onChange", "isDisabled"],
    _excluded2 = ["control"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { CalendarIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { Calendar } from 'react-calendar';
import { Controller } from 'react-hook-form';
import { usePopper } from 'react-popper';
import { useOnClickOutsideWithNode } from '../../hooks/useOnClickOutside';
import { formatDate } from '../../shared/formatters';
import Input from './Input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CalendarInput(_ref) {
  var value = _ref.value,
      className = _ref.className,
      inputClassname = _ref.inputClassname,
      format = _ref.format,
      calendarProps = _ref.calendarProps,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      isDisabled = _ref.isDisabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var displayValue = value ? formatDate({
    date: value,
    options: {
      month: '2-digit'
    }
  }) : '';

  var _useState = useState(null),
      referenceElement = _useState[0],
      setReferenceElement = _useState[1];

  var _useState2 = useState(null),
      popperElement = _useState2[0],
      setPopperElement = _useState2[1];

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start'
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var _useState3 = useState(false),
      isCalendarOpen = _useState3[0],
      setIsCalendarOpen = _useState3[1];

  useOnClickOutsideWithNode(popperElement, function () {
    return setIsCalendarOpen(false);
  });

  var handleChange = function handleChange(value) {
    var date = value;
    /**
     * Substract the offset and add it to the UTC timestamp
     * The calendar should always return 00:00 UTC of the selected date
     */

    if (value) {
      var offset = new Date(value).getTimezoneOffset() * 60000;
      date = new Date(value.getTime() - offset);
    }

    onChange(date);
    setIsCalendarOpen(false);
  };

  return /*#__PURE__*/_jsxs("div", {
    ref: setReferenceElement,
    className: "relative",
    onClick: function onClick() {
      if (!(props.disabled || isDisabled)) setIsCalendarOpen(true);
    },
    onFocus: function onFocus(e) {
      if (e.target.nodeName !== 'BUTTON') {
        setIsCalendarOpen(true);
      }
    },
    children: [/*#__PURE__*/_jsx(Input, _objectSpread({
      value: displayValue,
      className: clsx('cursor-pointer', className),
      inputClassname: clsx('cursor-pointer', inputClassname),
      readOnly: true,
      EndIcon: function EndIcon() {
        return /*#__PURE__*/_jsx(CalendarIcon, {
          className: "mr-2 w-5 text-black/60"
        });
      },
      onClear: function onClear() {
        return handleChange(null);
      },
      disabled: isDisabled || props.disabled
    }, props)), isCalendarOpen && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      ref: setPopperElement,
      className: "z-10 w-80",
      style: styles['popper']
    }, attributes['popper']), {}, {
      children: /*#__PURE__*/_jsx(Calendar, _objectSpread({
        value: value && typeof value === 'string' ? new Date(value) : value,
        className: "w-[400px]",
        onChange: handleChange
      }, calendarProps))
    }))]
  });
}
export default CalendarInput;
export var CalendarInputControlled = function CalendarInputControlled(_ref2) {
  var control = _ref2.control,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref3) {
      var _ref3$field = _ref3.field,
          value = _ref3$field.value,
          onChange = _ref3$field.onChange;
      return /*#__PURE__*/_jsx(CalendarInput, _objectSpread({
        value: value,
        onChange: onChange
      }, props));
    }
  }));
};